var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.65 16C30.65 7.9078 24.0902 1.35 16 1.35C7.90783 1.35 1.35 7.90786 1.35 16C1.35 24.0903 7.90777 30.65 16 30.65C24.0903 30.65 30.65 24.0903 30.65 16Z",
    fill: "#C6DDFF",
    stroke: "#002356",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3334_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99036 10H21.9503C22.7726 10 23.4453 10.675 23.4453 11.5V20.5C23.4453 21.325 22.7726 22 21.9503 22H9.99036C9.16811 22 8.49536 21.325 8.49536 20.5V11.5C8.49536 10.675 9.16811 10 9.99036 10Z",
    fill: "#FFCCAA",
    stroke: "#002356",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4453 11.5L15.9703 16.75L8.49536 11.5",
    stroke: "#002356",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3334_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9399,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.844d493b690ce7352755fbb0af73c790.svg";
export { ForwardRef as ReactComponent };